import React from 'react';
import '../SalesOrder.css';

const CustomerContact = ({ header, name, email, phone, modilePhone }) => {
  return (
    <div
      className="CustomerAddress CustomerAddress__Billing"
      style={{ marginTop: '12px' }}
    >
      <h5 className="CustomerAddress__Header">{header}</h5>
      <p className="CustomerAddress__Contents">
        <strong className="CustomerAddress__AccountName">{name}</strong>
      </p>
      <p className="CustomerAddress__Contents">{email}</p>
      <p className="CustomerAddress__Contents">{phone}</p>
      <p className="CustomerAddress__Contents">{modilePhone}</p>
    </div>
  );
};

export default CustomerContact;
